import { jsx as _jsx } from "react/jsx-runtime";
import { IconButton, TextField } from "@mui/material";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { forwardRef, useState } from "react";
/**
 * Mui TextField with an end adornment that shows/hides the input text
 * @param param0
 * @returns
 */
export const PasswordField = forwardRef((props, ref) => {
    const [showPassword, setShowPassword] = useState(false);
    return (_jsx(TextField, Object.assign({ ref: ref }, props, { InputProps: {
            endAdornment: (_jsx(IconButton, Object.assign({ onClick: () => setShowPassword(!showPassword), disabled: props.disabled, size: "large" }, { children: showPassword ? _jsx(Visibility, { color: "inherit" }) : _jsx(VisibilityOff, { color: "inherit" }) }))),
        }, type: showPassword ? "text" : "password" })));
});
